import * as catalogos from './catalogos/zh2';
export const locale = {
  lang: 'zh2',
  data: {
    'RESPONDE': catalogos.answer,
    'CONSULTATABLA': {
      'TITULO':	'一般数据',
      'HEADER':	'公司',
      'BUSCAR':	'搜索...',
      'EMPRESA':	'公司',
      'MESSAGE3':'<span> 如果您确定要对产品进行逻辑删除，请在文本框中输入红色文本：',
      'MESSAGE4':'</span>',
      'CANCELAR': '取消',
      'COMFIR': '确认',
      'PROC_DELE_PROD':'消除产品',
      'SUCC_DELE_PROD':'产品已成功移除',
      'DELE_PRODU':'删除产品',
      'TEX_VERS_RESULT_OPC1':'默认版本',
      'TEX_VERS_RESULT_OPC2':'自定义版本',
      'TEX_VERS_RESULT_LAB':'自定义版本',
      'TEX_PLAC_RESULT_LAB':'输入自定义版本',
      'TEX_MOD_RESULT_VERS':'你需要输入结果版本类型',
      'SELECT_PLANTILLA': '公司資料',
      'SELECT_EMAIL_PLANTILLA': '请选择一个模板',
      'ACCION':	'行动',
      'CREAT_DATE_EMP':'Date of creation',
      'TYP_REGISTR_EMP':'Type of registration',
      'AUTOR_EMP':'Author',
      'DETALLE':	'产品展示',
      'MANAGER_TI':	' 经理',
      'STATUS':'调查状况',
      'EMA_HISTO':'邮件历史',
      'LABEL1':	'公司資料',
      'DESCDETAIL':	'',
      'DETAIL':	'详情',
      'SECTOR':	'行业',
      'SUBSECTOR':	'子行业',
      'RANKING':	'排行',
      'SELECCIONE_FECHA': '日期',
      'SELECT_CSSID':'申请年份',
      'SELECT_CSSIDR': '排名年份',
      'TIPORANKING': '排名类型 ',
      'TIP_PRODU': '产品类型',
      'TIP_PLAN_PRO': '模板名称',
      'TIP_DIS_PRO': '设计',
      'SELECT_CSSID2': '选择设计',
      'SURVEYTK_TITU': '调查令牌',
      'SURVEYTK_DESC': '输入此产品的调查令牌',
      'TABLEAUVER_TITU': '结果版本',
      'TABLEAUVER_DESC': '输入该产品的结果系统版本',
      'IDOPORTUNITY': '机会 ID（销售队伍）',
      'NAMEOPORTUNITY': '机会名称（销售队伍）',
      'IDTYPERESULT': '结果类型',
      'NAM_USE_SWIFT':'用户名',
      'TO_USE_SWIFT':'合作者总数',
      'EMA_USE_SWIFT':'使用电子邮件',
      'PASS_USE_SWIFT':'用户密码',
       'CAT_RES':{
         '1':'完成结果',
         '2':'基本结果',
       },
      'PROYECTMANAGER': '项目经理',
      'PROYECTMANAGER_MAIL': '项目经理邮箱',
      'INFOR': '信息',
      'TIPO':	'類型',
      '0': 'White Icon Design',
      '1': 'Yellow Icon Design',
      '4': '图标设计圈',
      'Reactivos': 'Statements',
      'NPS': 'NPS',
      'Demograficos': 'Demographic',
      'Forall': 'Forall',
      'Adicionales': 'Additional',
      'Control': 'Control',

      'ADDPRODUCTS':	'添加產品',
      'ADD':	'加',
      'NAME_SURVEY':'调查名称:',
      'UPDATE_NAME_SURVEY':'将名称更新为',
      'LABELCONTRATADOS':	'使用中',
      'PRODUCTOS': catalogos.productos,
      'PRODUCTOSTURQUIA': catalogos.productosTurquia,
      'CATEGORIAS': catalogos.categorias,
      'GETLISTAEMP': '载入注册公司列表',
      'EDITAR': '编辑公司信息',
      'LOGIN': '登录',
      'PAGINATOR_1': '家公司中的',
      'PAGINATOR_2': '家',
      'ELIMINAR': '删除公司',
      'TIMELINE': '技术要求时间表',
      'CORREOMODIF': '该产品有电子邮件正文更改',
      'CORREOMODIFMODAL': '在一个或多个产品中，有新的电子邮件更改正在等待验证。 请检查一下',
      'CORREOMODAL_2':'新的电子邮件更改当前正在等待验证',
      'MODIFBTN': '产品设定',
      'INF_BTN': '产品信息',
      'INF_PROD_SEL': '产品信息',
      'VALIDMAIL_1': '验证变更',
      'VALIDMAIL_2': '验证邮件',
      'VALIDMAIL_3': '您是否要验证对消息所做的更改？',
      'VALIDMAIL_4': '电子邮件更改已正确验证',
      'VALIDMAIL_5': '拒绝更改',
      'VALIDMAIL_6': '您要拒绝对消息所做的更改吗？',
      'VALIDMAIL_7': '电子邮件正文的更改被拒绝。 而是使用默认的电子邮件模板',
      'VALIDMAIL_8': '邮件被拒',
      'VALIDMAIL_9': '启用对公司的编辑',
      'VALIDMAIL_10': '您是否要重新启用对公司的电子邮件编辑？',
      'VALIDMAIL_11': '该版本已为公司启用',
      'VALIDMAIL_12': '编辑邮件',
      'VALIDMAIL_13': '现在，您可以编辑公司发送的电子邮件',
      'SINCORREOS': '没有电子邮件可以验证',
      'FILEMANODS': '文件管理器',
      'TEX-MENS-1':'公司',
      'TEX-MENS-2':'无用户',
      'FILEMAN_PRIV': '私人文件夹',
      'FILEMAN_PUB': '公用文件夹',
      'USUARIO':'用户',
      'AL':'至',
      'SEN_EMAIL_REQ':'您要发送技术要求电子邮件',
      'SEN_EMAIL_REQ_PROD':' 請務必發送技術要求電子郵件',
      'ETIQUE_SEN_EMAIL_REQ_PROD':' 郵寄技術要求',
      'EMAIL_REQ_PLACE': '選擇一種語言',
      'EMAIL_REQ_INTRO':'請選擇一種語言繼續',
      'WARN_SEN_EMAIL_REQ_PROD': '要继续，您必须选择一种语言',
      'TOOLTI_SEN_EMA':' 發送郵件 ',
      'ESTA_EMA_TRUE':' *已發送郵件',
      'ESTA_EMA_FALSE':'*未發送的郵件',
      'SEN_EMAIL_MODAL':'正在发送电子邮件...',
      'RTINFO': '技术要求信息',
      'TOOTI_RES_EMPR':'结果令人印象深刻',
      'WARNI_SELCT_CHECK':'要继续搜索，必须至少选中一个框',
      'REQ':{
        'BTNSI':'是',
        'BTNNO':'不',
        'MENSAJE1':'您要禁用技术要求吗？',
        'MENSAJE2':'您要激活技术要求吗？',
      },
      'EDITORMAILODS': {
        'OPCION_1': '激活此产品的电子邮件编辑器',
        'OPCION_2': '自动确认变更',
        'OPCION_3': '激活调查过程中的需求详细信息',
        'OPCION_4': '激活重点区域的调查验证',
        'OPCION_5': '允許更改申請時間',
        'OPCION_6': '允许扩展',
        'OPCION_7':'成功完成调查过程中的需求详细信息的机会',
        'OPCION_8': '可分配的提醒数',
        'OPCION_9': '激活截止日期版本',
        'OPCION_11_ENTREGABLES': '在计数门户中显示可交付成果的结果',
        'OPCION_11_RANKING': '在Counting Portal中显示认证结果和排名',
        'OPCION_13':'启用随机验证问题',
        'OPCION_14':'在Survey App中显示说明框',
        'OPCION_15':'在Survey App中显示支持框',
        'OPCION_16':'在调查应用程序中显示用户名',
        'MODAL_OP1_ON': '此产品的电子邮件编辑器已激活',
        'MODAL_OP1_OFF': '该产品的电子邮件编辑器已被禁用',
        'MODAL_OP2_ON': '此产品已激活自动更改验证',
        'MODAL_OP2_OFF': '已禁用此产品的自动更改验证',
        'MODAL_OP6_ON': '已允许该产品的翻转功能',
        'MODAL_OP6_OFF': '该产品的允许翻转已被停用',
        'MODAL_OP7_ON': '该产品的可分配提醒数已更改',
        'MODAL_OP8_ON': '已激活该产品的调查截止日期的编辑',
        'MODAL_OP8_OFF': '禁用此产品的调查关闭日期的编辑功能已被禁用',
        'MODAL_OP11_ENTREGABLES_ON': '可交付成果的样本已激活 ',
        'MODAL_OP11_ENTREGABLES_OFF': '可交付成果的样本已停用',
        'MODAL_OP11_RANKING_ON': '认证和排名结果样本已激活',
        'MODAL_OP11_RANKING_OFF': '认证样本和排名结果已停用',
        'MODAL_PIN_ON':'引脚已启用',
        'MODAL_PIN_OFF':'引脚已禁用',
        'MODAL_PRECONTROL_ON':'随机验证问题已激活',
        'MODAL_PRECONTROL_OFF':'随机验证问题已禁用',
        'MODAL_OP14_ON':'在调查应用程序中显示指令框处于活动状态',
        'MODAL_OP14_OFF':'已禁用在调查应用程序中显示指令框',
        'MODAL_OP15_ON':'已激活调查应用程序中的显示支持面板',
        'MODAL_OP15_OFF':'已禁用调查应用程序中的显示支持框',
        'MODAL_OP16_ON':'在调查应用程序中显示用户名处于活动状态',
        'MODAL_OP16_OFF':'已禁止在调查应用程序中显示用户名',
        'TITUOPTS': '选件',
        'TITUCORRS': '电子邮件验证',
        'SELLANG': '从列表中选择一种语言以查看电子邮件',
        'SELLANG_L': '选择一种语言',
        'ASUNTO': '邮件主题',
        'ASUNTOPILOTO': '试点邮件主题',
        'WAIT':'储存变更',
        'ULTD': '无限',
        'CLOUD_LEGACY': '激活文件管理器的更新版本',
        'CUSTOM_TEXT_CERT': '激活多站点证书文本',
        'CUSTOM_TEXT_CERT_EDIT': '编辑证书文本',
        'TEXT_SECC_CONF_VOIC': '显示语音配置部分',
        'SAVED_CHANGES': '更改已成功保存',
        'CUSTOM_TEXT': {
          'TITULO': '列出多站点证书覆盖的国家/地区',
          'SUBTITULO': '编写新文本',
          'SUBTITULO2': '警告，如果您更改文本并单击“确定”按钮，当前文本将被覆盖',
          'HINT': '证书文本',
          'OK': '接受',
          'CANCEL': '取消',
          'SAVED_CHANGES': '文本已正确保存',
          'CURRENT_T1': '当前多站点文本',
          'CURRENT_T2': '当前多站点文本很长，点击编辑按钮查看',
        }
      },
      'ASOCIARCERTIFICAR':{
        'CHECK':'将文化审核与证书相关联',
        'INPUT':'要关联的证书',
        'INPUT_2':'要关联的产品',
        'CERTIFICAR':'证明',
        'MEDIR':'措施',
      },
      'LOG_SENDGRIND':{
        'TITULO':'SendGrid的日誌',
        'OPCION':'選擇一個選項：',
        'TOOLTIP':'搜索狀態',
        'TABLA':{
          'USUARIO':'用戶',
          'EMAIL':'電子郵件',
          'ASUNTO':'學科',
          'ESTATUS':'狀態'
        },
        'DIALOG_SENDGRIND':{
          'TITTULO':'郵寄信息',
          'TO':'至',
          'FROM':'從',
          'SUBJECT':'學科',
          'HISTORIAL':'郵件記錄',
          'ESTATUS':'狀態',
          'ABIERTO':'營業時間：',
          'ULTIMO_EVENTO':'最後事件：',
          'SIN_CORREOS':'您的電子郵件歷史記錄不可用！',
          'BOTON':'關',
          'NOTE':'注意：列表中顯示的日期時間/時間設置為本地時間',
        },
      },
      'CONFIR_CAMBIOS_SECCION':'当前调查已创建，\n\n您确定要进行更改吗？\n\n 如果您确认，请再次生成调查',
      'MODAL_CAMBIOS_SECCION':'更新部分',
      'TIT_MOD_AGRE_ENCU':'新调查流程',
       'TEX_NAM_SUR':'调查名称：',
       'TEX_PLA_SUR':'模板选择',
       'BTN_AGRE_SUR':'添加',
       'PLA_TEX_NAM_SUR':'调查名称：',
       'PLA_TEX_PLA_SUR':'模板选择',
       'WARNI_NOT_SURV_NOM35':'调查当前未生成',
       'MODAL_CREAT_INFRA':'基础设施正在创建中，请等待',
       'MODAL_ERROR_INFRA':'创建基础设施时发生错误',
    },
    'ALERTS': {
      'OK':	'好',
      'ODSINSERTOK':	'SDG已成功注册。',
      'ODSFAILINSERT':	'注册失败，请重试',
      'COLPLETEFORM1':	'请完成步骤1',
      'COLPLETEFORM2':	'请完成步骤2',
      'COLPLETEFORM3':	'请完成步骤3',
      'COLPLETEFORM4':	'请完成步骤4',
      'COLPLETEFORM5':	'请完成步骤5',
      'PASSWORD': {
        'LONGITUD': '密码必须至少八个字符',
        'MINUSCULAS': '密码必须至少包含一个小写字母',
        'MAYUSCULAS': '密码必须至少有一个大写字母',
        'NUMEROS': '密码必须至少包含一个数字字符',
        'ESPCHARS': '密码必须至少包含一个特殊字符，而不是字母数字',
        'VALIDACION': '验证密码时出现问题，请再次输入该密码，然后尝试重新创建用户'
      }
    },
    'TI_MANAGER': {
      'TITULO':	'IT经理',
      'DESCRIPTION':	'输入IT经理的数据，以便发送调研前必须执行的设置数据。',
      'DATOS':	'资料',
      'NOMBRE': '名称',
      'APELLIDOS': '姓',
      'EMAIL': '电子邮件',
      'TELEFONO': '电话',
      'EXTENSION': '延期',
      'CELULAR': '手机',
    },
    'PERFILES': {
      'CABECERA':{
        'TITULO': '档案创建者',
        'DESCRIP': '描述,'
      },
      'BOTONES':{
        'BOT1':{
          'TITULO': '公司简介',
          'BOTON': '创造'
        },
        'BOT2':{
          'TITULO': '用户资料',
          'BOTON': '管理员'
        },
        'BACK': '背部',
        'NEXT': '下一个',
        'RESET': '再生',
        'EDIT': '保存'
      },
      'EMPRESA':{
        'TITUHEAD': '公司简介',
        'CLOUD': '私人文件夹',
        'INFO': '创建公司资料',
        'INFOMOD': '您可以修改该公司的个人资料数据<b>（更改会自动保存）</b>',
        'PDF':{
          'BOTONDESCARGA':'以pdf格式下载信息',
          'FECHA':'日期： ',
          'HORA':'时间： ',
          'MODAL':'正在生成文件供下载...',
        },

        'ACTUALIZARCA':{
          'ACTUALIZARCA':'更新文化审核',
          'ACTUALIZARCA_BRI':'更新文化简介',
          'ACTUALIZARCA_ACTIAN':'更新行动计划',
          'CERRAR':'关',
          'SUCCESS':'文化审核成功更新',
          'SUCCESS_ACTION':'Plan action successfully updated',
          'ERROR':'错误，您的文化审核没有认证的产品',
          'ERROR_ACTION':'Error, your Plan action does not have a certified product',
        },


        'SECCIONES':{
          'SEC1': {
            'TITULO': '公司资料',
            'TITULOPDF': '公司资料 ',
            'NOMEMP': '公司名称',
            'NOM': '名',
            'ANIOFU': '基础年',
            'INSTITUTO': '研究所',
            'SALESFORCE': '编号 销售人员',
            'CODE': '项目编号',
            'SALES_REQUIRED': '编号 需要销售人员',
            'CODE_REQUIRED': '必须输入项目代码',
            'INSTITUTO_REQUIRED': '学院是必需的',
            'COMPANY': '公司名称',
            'COMPANY_REQUIRED': '公司名称为必填项。',
            'CAMPO_INVALID': '该字段不允许以下字符 /*?"<>:\'',
            'COMPANY_ACOR': '公司短名',
            'MOD_INGRE_ACORT': '要继续输入公司短名',
            'ACORT_REQUIRED': '公司短名称是必需的',
            'SEDE': '东道国',
            'SEDE_REQUIRED': '需要选择东道国才能继续',
            'PUBLICATION': '刊物名称',
            'PUBLICATION_REQUIRED': ' 出版物名称为必填项',
            'FUNDATION': '基础年',
            'FUNDATION_REQUIRED': '必须是公司成立的年份。',
            'EMP_TC_REQUIRED': '需要全职雇员人数。',
            'EMP_TP_REQUIRED': '请填写兼职员工人数',
            'TOTCOL_REQUIRED': '请填写合作者总数',
            'RANKING': '耙',
            'RANKING_REQUIRED': '请选择排名',
            'TIPO': '员工范围',
            'TIPO_REQUIRED': '请选择一种类型',
            'MULTINACIONAL': '跨国公司',
            'MULTINACIONAL_REQUIRED': '请选择是否是跨国公司',
            'ANIORANK_REQUIRED': '输入排名年份',
            'REGION': '地区',
            'REGION_REQUIRED': '输入您的地区',
            'PAIS': '国家',
            'ESTADO': '州，市或省',
            'NAM_RANKIN':'排名名称',
            'TYP_RANKIN':'类型排名',

            'OPTSI': '是的',
            'OPTNO': '否',

            'EMP_TC': '全职员工',
            'EMP_TP': '兼职员工',
            'TOTCOL': '合作者总数',
            'ANIORANK': '排名年份',
            'ETIQ_CATALOGOS':{
              'SECTOR': '选择一个部门',
              'SUBSECTOR': '选择一个子行业',
              'MULTIN': ' 跨国公司',
              'TIPO': '类型（等级或扇区）',
              'REGION': '选择一个地区'
            },
            'CATALOGOS':{
              'INSTITUTOS': catalogos.institutos,
              'SECTORES': catalogos.sectores,
              'RANKING': catalogos.ranking,
              'REGIONES': catalogos.regiones,
            }
          },
          'SEC2': {
            'TITULO': '项目经理',
            'NOM': '名',
            'APE': '姓氏',
            'EMAIL': '电邮地址',
            'TEL': '电话号码',
            'EXT': '扩展名',
            'CEL': '手机',

            'APE_REQUIRED': '输入您的姓氏',


            'NOM_REQUIRED': '输入名字',
            'EMAIL_REQUIRED': '输入你的邮箱',
            'TEL_REQUIRED': '输入您的电话号码',
            'EXT_REQUIRED': '输入扩展名',
            'CEL_REQUIRED': '输入你的手机'

          },
          'SEC3': {
            'TITULO': '人力资源总监',
            'NOM': '名',
            'APE': '姓氏',
            'EMAIL': '电邮地址',
            'TEL': '电话号码',
            'EXT': '扩展名',
            'CEL': '手机',

            'NOM_REQUIRED': '输入名字',
            'EMAIL_REQUIRED': '输入你的邮箱',
            'TEL_REQUIRED': '输入您的电话号码',
            'EXT_REQUIRED': '输入扩展名',
            'CEL_REQUIRED': '输入你的手机'

          },
          'SEC4': {
            'TITULO': '信息技术经理',
            'NOM': '名',
            'APE': '姓氏',
            'EMAIL': '电邮地址',
            'TEL': '电话号码',
            'EXT': '扩展名',
            'CEL': '手机',

            'NOM_REQUIRED': '输入名字',
            'EMAIL_REQUIRED': '输入你的邮箱',
            'TEL_REQUIRED': '输入您的电话号码',
            'EXT_REQUIRED': '输入扩展名',
            'CEL_REQUIRED': '输入你的手机'
          },
          'SEC5': {
            'TITULO': '可交付成果',
            'ENTRE': '可交付成果',
            'TIPO': '型式',

            'ENTRE_REQUIRED': '输入可交付成果',
          }
        },
        'MENSAJES':{
          'CARGABD': '上传数据库',
          'STATUS': '州',
          'CORRECTO': '公司资料已正确创建',
          'ERROR': '创建公司资料时发生错误'
        }
      },
      'USUARIO':{
        'TITULO_LOGIN':'选择您要用来登录的用户',
        'MJS_COMPLETE_INFO': '请填写信息。',
        'MSJ_INVALIDEMAIL': '请输入有效电子邮件。',
        'MSJ_SELECTCOMPANY': '请选择公司',
        'REGISTER_SUCCESS': '用户注册成功',
        'REGISTER_SUCCESS_SWIFT': '用户注册成功，已向您的用户发送一封激活邮件',
        'REGISTER_ERROR': '错误，用户无法注册，请重试',
        'PRODUCT_REGISTEROK': '产品正确注册。',
        'PRODUCT_REGISTERPREVIOUS': '先前注册的产品。',
        'PRODUCT_REGISTERFAIL': '注册产品时出错，请重试',
        'CERTIFICAR_EXISTENTE': '认证产品已经存在',
        'CERTIFICAR_NO_TERMINADO': '要添加以下产品，您必须以当年证书结尾',
        'CERTIFICAR_NO_EXISTENTE': '要添加Pulsecheck产品，您必须获得当年的证书',
        'PULSOS-COMPLETOS':'目前您有允许的脉搏',
        'MSJ_SELECTYEAR': '请选择一年',
        'MSJ_SELECTPRODUCT': '请选择一个产品',
        'MSJ_SELECTTEMPLETE': '请选择一个模板',
        'MSJ_SELECTEMAILTEMPLETE': '请选择一个模板',
        'SIN_USUARIO': '您需要注册该公司的用户才能添加此产品',
        //'SIN_SURVEYTOKEN': '您需要输入调查令牌以关联到该产品才能进行分配',
        'MISMOANIOCERTIFICAR': '无法添加该产品，您已有同年的 Certify 产品，请选择其他年份并重试',
        'SIN_SURVEYTOKEN': '该产品的年份还没有调查',
        'SIN_CERTIFICAR_ASOCIA': '您仍然需要关联认证产品',
        'SIN_TABLEAUVER': '您需要输入结果版本以关联到该产品才能进行分配',
        'SINRANKING': '您需要选择该产品的排名年份才能继续',
        'SINTIPORANK': '在继续之前，您需要选择该产品的排名类型',
        'SINIDOPORTUNITY': '在继续之前，您需要输入此产品的机会 ID',
        'SINNAMEOPORTUNITY': '您需要在继续之前输入该产品的机会名称',
        'SINIDTYPERESULT': '您需要输入此产品的结果类型才能继续',
        'SINPROYECTMANAGER': '您需要输入此产品的项目经理姓名才能继续',
        'SINCORREOPM': '您需要输入此产品的项目经理的电子邮件才能继续',
        'EMAILNOVALIDO': '输入的项目经理邮箱格式不正确，请检查并重新正确输入',
        'GUARDANDOPRODUCTO': '所选产品正在加入公司，请稍等',
        'TOKENMODAL_1': '这是新增产品的调查令牌',
        'TOKENMODAL_2': '你想下一步该做什么？',
        'TOKEN_SI': '复制令牌',
        'TOKEN_NO': '继续',
        'TOKEN_COPIADO': '调查令牌已成功复制到剪贴板',

        'TITUHEAD': '用户资料',
        'TITUCREARHEAD': '创建用户',
        'TITUBUSCARHEAD': '搜索用户',
        'TITUBUSCAREMPRESA': '搜索公司',
        'TITUUSERGPTWHEAD': '管理员用户',
        'INFO': '用户个人资料',
        'USUARIO': '用户',
        'USE_NAM': '用户名',
        'USUARIOREQUIRED': '需要用户',
        'USUARIONAMEREQUIRED': '用户名是必需的',
        'CONTRAREQUIRED': '密码为必填项',
        'LEVELREQUIRED': '选择一个级别',
        'CONTRA': '密码',
        'COMPANY': '公司',
        'NIVEL': '水平',
        'NIVELES': catalogos.niveles,
        'GUARDA': '救',
        'TH-NOMEMPRE':'公司名',
        'TH-USUARIO':'用户',
        'TH-TUSUARIO':'用户类型',
        'TH-ACCIONES':'动作',
        'TH-LOGIN':'登录',
        'TH-INSTITUTO':'研究所',
        'ACC-DELET':'删除用户',
        'ACC-EDIT':'编辑使用者',
        'UPDATE-USER':'正确更新',
        'EXIST-USER':'现有用户',
        'ALERT-EDIT':'您确定要修改用户吗？',
        'USUARIO-T':'用户数',
        'CONFIRM_ELIMINAR_USU':'您确定要删除该用户吗?',
        'INGR_ELIMINAR_USU':'<span>在文本字段中输入用红色标记的用户 ',
        'INGR_ELIMINAR_USU.2':'</span>',
        'ERROR_ELIMINAR_USU':'输入的用户不匹配',
        'OK_ELIMINAR_USU':'用户已正确删除',
        'PASSWORDSAFE': '密码长度至少为8个字符：至少1位数字，至少1个小写字母，至少1个大写字母和至少1个非字母数字字符',
        'PRODUCT_EXIST':'所选日期的产品已经存在',
        'WAR_ADD_NA_US':'请输入用户名',
         'WAR_ADD_TOT_US':'请输入合作者总数',
         'WAR_ADD_EMA_US':'请输入用户邮箱',
         'WAR_ADD_PASS_US':'请输入用户密码',
         'WAR_INCO_EMA_US':'输入的邮箱不正确',
         'WAR_INCO_PASS_US':'密码不是允许的格式',
         'MOD_SAV_US':'保存用户',
        'MENSAJES':{
          'CARGABD': '上传资料库',
          'STATUS': '状态',
          'CORRECTO': '用户个人资料已成功创建',
          'ERROR': '创建用户个人资料时发生错误'
        }
      }
    },
    'CONSULTARENCUESTA':{
      'TITULO': '咨询调查',
      'HEADER': '选择学院',
      'INSTITUTOS': '研究所',
      'FILTRO': '过滤',
      'FILTRO_EMPRESA':'过滤公司',
      'FILTRO_TI_EMPR_TOKEN':'过滤令牌调查/公司类型',
      'SELECCIONFILTRO': '搜索所需信息',
      'BOTON_DESCARGA_EXCEL': '以excel格式下载信息',

      'CARGANDO': '加载信息...',
      'NOMBRE_DE_EMPRESA': '公司的名称',
      'TIPO_DE_EMPRESA':'公司类型',
      'FECHA_C': '创建日期',
      'SECTOR': '部门',
      'SUBSECTOR': '分部门',
      'TIPO_ENC': '调查类型',
      'PLANTILLA': '模板',
      'CATALOGOSPRODUCTOS': catalogos.plantillas,
      'TOKEN': '代币',
      'ID_ENC': '调查编号',
      'ANIO': '年',
      'CORREOS_EN': '邮件已发送',
      'FECHA_A': '申请日期',
      'FECHA_CR': '截止日期',

      'MODAL_SUCCES': '档案已正确下载',
      'MODAL_WARNING': '未选择研究所',
      'VIZUENCU':'显示调查',
      'SELE_AN_ENCU':'Seleccione un año',
    },
    'CONSULTAR_RT':{
      'TITULO':'咨询技术要求',
      'HEADER': '选择学院',
      'INSTITUTOS': '研究所',
      'FILTRO': '筛选',
      'SELECCIONFILTRO':'搜索所需的公司',
      'CARGANDO':'加载信息',
      'NOMBRE_DE_EMPRESA':'公司名称',
      'FECHA_DE_EMPRESA':'创建日期',
      'PRODUCTO':'产品类型',
       'TOKEN':'调查令牌',
       'ESTATUS':'Status',
       '0':'未开始',
       '1':'处理中',
       '2':'完成',
       'ACCIONES':'动作',
      'PRODUCTOS':catalogos.productos,
      'ELEMENTOS':'每页项目数',
       'DE':'of',
       'SIGUIENTE':'下一步',
       'ULTIMA':'最后一页',
       'PRIMERA':'第一页',
       'ANTERIOR':'上一个',

    },
    'AUDITORIA-AUTOMATICA':{
      'TITULO': '自动审核',
      'TABLA':{
        'TH-NOM-EMPRESA':'公司名',
        'TH-NO-COLAB':'否。合作者',
        'TH-CONTESTADOS':'已回答',
        'TH-FALTANTES':'失踪',
        'TH-PROGRESO':'进展',
        'TH-ACCIONES':'动作',
        'MSJ-DETALLES':'阅读详情',
      }

    },
    'RESULTA-AUDITO':{
      'TIEM-RES-TAB':'协作者的响应时间',
      'RES-CONT-TAB':'控制响应',
      'RES-COMENT-TAB':'评论回应',
      'TIEM-RES-TITULO':'检查合作者的响应时间',
      'RES-CONT-TITULO':'控制问题答案的百分比',
      'RES-COMENT-TITULO':'为空，重复或包含重复字符的注释的百分比',
      'RES-AGREGAR':'添加样本',
      'RES-SELECCIONAR':'选择样品',
      'RES-TEXTO1':'尚未创建任何示例',
      'RES-TEXTO2':'请选择一个样本以查看数据',
      'INGRE-NOM':'输入样品名称',
      'SELEC-REG':'选择样本规则',
      'REGLAS':{
        '1':'在不到10分钟的时间内回答的协作者',
        '2':'回答了所有项目的合作者的价值为5',
        '3':'对控制权问题回答是的协作者',
        '4':'错误回答随机问题的协作者',
        '5':'合作伙伴更改了10个以上答案',
      },

      'TABLA':{
        'TITULO':'样本中合作者的数据',
        'NOMBRE':'名称',
        'TELEFONO':'电话',
        'CELULAR':'Cellular',
        'CORREO':'电子邮件地址',
        'COMENTARIO':'Commentary',
      },
      'MODALES':{
        'GENERANDO':'正在生成样本，请稍候...',
        'GUARDANDO':'正在保存评论，请稍候...',
        'TITULO':'保存的评论',
        'CERRAR':'关闭',
        'TITULO_INFORMACION':'一旦添加了注释，该字段就不能为空，将使用保存在其中的最后一个数据',
        'SUCCE-MUES':'示例已正确创建',
        'WARNI-SINU':'没有更多的用户可以注册',
        'WARNI-CONDI': '不要忘了命名并选择至少一条规则',


      },
    },
    'DESCARGAR_ENCUESTA':{
      'NPS':'NPS',
      'REACTIVOS':'陈述',
      'CONTROL':'控制',
      'DEMOGRAFICOS':'客层',
      'ABIERTAS':'打开',
      'CA':'4ALL',
      'CODIGOPROYECTO':'项目代码: ',
      'ANIOAPLICACION':'实施年份: ',
      'MENSAJE':'由于尚未创建调查，因此无法下载该调查',
      'ACEPTAR':'接受',
      'TEXTODESCARGA':'调查 ',
      'DESCARGARENCUESTA':'下载问卷',
      'INFORMACIONYAVISO':'调查信息和隐私声明',
      'SECCIONES':'栏目',
      'MODAL':{
        'TITLE':'语言清单',
        'SUBTITLE':'选择一种语言',
        'PLACEHOLDER':'没有',
        'BTNCLOSE':'关闭',
        'BTNSELECT':'去下载'
      }
    },
    'INFORT': {
      'TITULO': '技术要求进度',
      'SINLANGS': '您需要选择此产品中的语言以查看步骤列表',
      'PASOS': {
        'PASO_1': '步骤清单',
        'PASO_2': '问卷调查',
        'PASO_3': '记录'
      },
      'LISTAPASOS': {
        'autentication': '调查认证',
        'testAccess': '显示测试',
        'testEmail': '电子邮件接收证明',
        'validationQ': '验证问卷',
        'requirements': '数据隐私政策',
      },
      'STATUS': {
        'PEND': '待办的',
        'DONE': '步骤完成',
      },
      'RESP': '回复已发送',
      'NORESP': '未回答'
    },
    'MODAL_CONSULT_INFRAESTRU':{
      'TITL':'专门的基础设施:',
      'INSTRUC_1':'你希望添加专用基础设施吗？',
      'LAB_SUBDOMINIO':'子域',
      'WARN_CARACT':'该字段不允许出现字母ñ、大写字母和特殊字符',
      'BTN_CONTI':'继续',
      'SI':'是',
      'NO':'No',
      'MODA_IMPORT_SUBDOM':'要继续，你必须输入子域',
    }
  }
};
